import { FilterEditProps } from '.';

/**
 * Contract for all ranged values. They contain 2 values, to and from.
 * This is preferable to an array with 2 elements.
 *
 * @export
 * @interface RangedValue
 */
export interface RangedValue {
	fromValue: any;
	toValue: any;
}

export interface RangedPresetValue extends RangedValue {
	preset?: string; // Today, ThisWeek, Last90Days, etc
	displayName?: string; // Today, This Week, Last 90 Days, etc
	axisPrecision?: 'day' | 'week' | 'month'; // Determines if the period is short enough, to be displayed in days precision in a graph axis.
}

export interface MultipleRangedPresetValueFilterEditProps extends FilterEditProps<RangedPresetValue[]> {}

export interface SingleRangedPresetValueFilterEditProps extends FilterEditProps<RangedPresetValue> {}

export interface SingleDateFilterEditProps extends FilterEditProps<RangedPresetValue[]> {}

/**
 * All available filter edit component types
 *
 * @export
 * @enum {number}
 */
export enum FilterType {
	SingleText = 'SingleText',
	MultipleText = 'MultipleText',

	MultipleDropdown = 'MultipleDropdown',
	SingleDropdown = 'SingleDropdown',

	SingleBoolean = 'SingleBoolean',
	SingleInteger = 'SingleInteger',
	SingleDecimal = 'SingleDecimal',

	SingleAutoSuggest = 'SingleAutoSuggest',
	MultipleAutoSuggest = 'MultipleAutoSuggest',

	RangedInteger = 'RangedInteger',
	RangedDecimal = 'RangedDecimal',

	MultipleDateRangePreset = 'MultipleDateRange',
	SingleDateRangePreset = 'SingleDateRange',
	SingleDate = 'SingleDate',
}
